@for (link of links; track link.label) {
  <a class="legal-footer-link" [href]="link.url" target="_blank">{{
    link.label
  }}</a>
}
